export default __webpack_public_path__ + "static/media/MD.222d59ef.jpeg";